import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faPeopleSimple } from '@fortawesome/pro-duotone-svg-icons/faPeopleSimple';
import { faPaw } from '@fortawesome/pro-duotone-svg-icons/faPaw';
import { faChildren } from '@fortawesome/pro-duotone-svg-icons/faChildren';

import { t } from 'i18next';
import { IconText } from './IconText';
import { useDependencies } from '../../../../dependencies';
import { FlowType } from '../../../../models/FamilyRegistrationStore/constants';

const DependentsSummary = (): JSX.Element => {
  const { stores: { familyRegistration } } = useDependencies();

  const { countDependents, childrenAges, flowType, childrenAgesString } = familyRegistration;

  if (familyRegistration.flowType === FlowType.HouseholdServices) {
    return <> </>
  }

  const icon = ((): IconDefinition => {
    switch (flowType) {
      case FlowType.SeniorCare:
        return faPeopleSimple;
      case FlowType.PetCareRecurring:
        return faPaw;
      default:
        return faChildren;
    }
  })();

  const text = ((): string => {
    switch (flowType) {
      case FlowType.SeniorCare:
        return `${countDependents} ${countDependents === 1 ? t('pages.nux.family.count.adult') : t('pages.nux.family.count.adults')}`;
      case FlowType.PetCareRecurring:
        return `${countDependents} ${countDependents === 1 ? t('pages.nux.family.count.pet') : t('pages.nux.family.count.pets')}`;
      default:
        return `${childrenAges.length} ${childrenAges.length === 1 ? t('pages.nux.family.count.child') : t('pages.nux.family.count.children')} ${childrenAgesString}`;
    }
  })();

  return <IconText icon={icon} text={text} />;
};

export { DependentsSummary };
